import { render } from "./NotificationsChatbot.vue?vue&type=template&id=7472304b&scoped=true"
import script from "./NotificationsChatbot.vue?vue&type=script&lang=js"
export * from "./NotificationsChatbot.vue?vue&type=script&lang=js"

import "./NotificationsChatbot.vue?vue&type=style&index=0&id=7472304b&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7472304b"]])

export default __exports__